module.exports = __webpack_public_path__ + "media/custom/images/img19-015a86f10d2f18423abd5a7f03d3c3fa.png";